import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export const Home = () => {
  return (
    <Box>
      <Card
        sx={{
          py: 2,
          px: 6,
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" gutterBottom>
              Início
            </Typography>
            <hr />
            <Typography component="div">
              <Box fontWeight="bold">
                <Typography align="center" gutterBottom>
                  Página inicial
                </Typography>
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};
